<template>
  <v-container fluid class="pa-5">
    <!-- Encabezado -->
    <v-sheet
      class="pa-4 mb-4 d-flex align-center justify-space-between flex-wrap ga-2"
      color="#194c9b"
      rounded
      elevation="2"
    >
      <div class="d-flex align-center ga-2">
        <v-icon color="white">mdi-office-building-outline</v-icon>
        <h1 class="text-h5 font-weight-bold text-white">
          Unidades de Negocio
        </h1>
      </div>
      <v-btn color="white" variant="flat" @click="abrirCrear">
        <v-icon start>mdi-plus</v-icon>
        Nueva unidad
      </v-btn>
    </v-sheet>

    <!-- Tabla -->
    <v-card rounded="lg" variant="outlined">
      <v-data-table
        v-model:expanded="expanded"
        :headers="headers"
        :items="unidades"
        :loading="loading"
        item-value="id"
        show-expand
        no-data-text="No hay unidades de negocio"
        loading-text="Cargando..."
      >
        <template #item.proyectosCount="{ item }">
          <v-chip size="small" variant="tonal" color="primary">
            {{ proyectosDe(item).length }}
          </v-chip>
        </template>

        <template #item.es_base="{ item }">
          <v-chip v-if="item.es_base" size="x-small" color="#c1121f" variant="flat">
            Base
          </v-chip>
          <span v-else class="text-medium-emphasis">—</span>
        </template>

        <template #expanded-row="{ columns, item }">
          <tr>
            <td :colspan="columns.length" class="py-3">
              <div
                v-if="proyectosDe(item).length"
                class="d-flex flex-wrap ga-2"
              >
                <v-chip
                  v-for="p in proyectosDe(item)"
                  :key="p.key"
                  size="small"
                  variant="outlined"
                  color="primary"
                >
                  <v-icon start size="16">mdi-folder-outline</v-icon>
                  {{ p.label }}
                </v-chip>
              </div>
              <span v-else class="text-medium-emphasis text-caption">
                Sin proyectos asignados
              </span>
            </td>
          </tr>
        </template>

        <template #item.actions="{ item }">
          <v-btn
            icon
            variant="text"
            color="primary"
            size="small"
            title="Editar"
            @click="abrirEditar(item)"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            icon
            variant="text"
            color="error"
            size="small"
            title="Eliminar"
            @click="eliminar(item)"
          >
            <v-icon>mdi-delete-outline</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <!-- Dialogo crear / editar -->
    <v-dialog v-model="dialog" max-width="600">
      <v-card rounded="lg">
        <v-card-title class="text-subtitle-1 font-weight-bold">
          {{ editando ? "Editar unidad" : "Nueva unidad" }}
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-text-field
            v-model="form.nameUnitBussines"
            label="Nombre de la unidad"
            variant="outlined"
            autofocus
            :error-messages="errorNombre"
            @update:model-value="errorNombre = []"
          />
          <v-textarea
            v-model="form.inference_profile"
            label="Perfil de inferencia Haiku"
            variant="outlined"
            rows="2"
            auto-grow
          />
          <v-row dense>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="form.underlying_model"
                label="Modelo base (underlying model Haiku)"
                variant="outlined"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="form.aws_region"
                label="Región AWS"
                variant="outlined"
              />
            </v-col>
          </v-row>
          <v-textarea
            v-model="form.sonnet_profile"
            label="Perfil de Inferencia Sonnet Claude"
            variant="outlined"
            rows="2"
            auto-grow
          />
          <v-text-field
            v-model="form.sonnet_pricing"
            label="Modelo Base Sonnet (underliying model)"
            variant="outlined"
          />
          <v-switch
            v-model="form.es_base"
            color="#c1121f"
            label="Unidad base (fallback cuando otra unidad no tiene perfil)"
            hide-details
            inset
          />
        </v-card-text>
        <v-divider />
        <v-card-actions class="justify-end">
          <v-btn variant="text" @click="dialog = false">Cancelar</v-btn>
          <v-btn
            color="primary"
            variant="elevated"
            :loading="saving"
            @click="guardar"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { swal } from "@/utils/swal";
import { useSettingsStore } from "@/stores/settings";
import {
  getUnidades,
  createUnidad,
  updateUnidad,
  deleteUnidad,
} from "@/api/unidadesNegocio.js";

export default {
  name: "UnidadesNegocio",
  data() {
    return {
      unidades: [],
      expanded: [],
      loading: false,
      saving: false,
      dialog: false,
      editando: false,
      form: {
        id: null,
        nameUnitBussines: "",
        inference_profile: "",
        underlying_model: "",
        aws_region: "",
        sonnet_profile: "",
        sonnet_pricing: "",
        es_base: false,
      },
      errorNombre: [],
      headers: [
        { title: "ID", key: "id", width: 90 },
        { title: "Nombre", key: "nameUnitBussines" },
        {
          title: "Proyectos",
          key: "proyectosCount",
          sortable: false,
          width: 120,
        },
        { title: "Base", key: "es_base", sortable: false, width: 90 },
        {
          title: "Acciones",
          key: "actions",
          sortable: false,
          align: "end",
          width: 120,
        },
      ],
    };
  },
  computed: {
    isDark() {
      return useSettingsStore().theme === "dark";
    },
  },
  mounted() {
    this.cargar();
  },
  methods: {
    popupClass() {
      return {
        popup: this.isDark ? "mi-popup" : "mi-popup-2",
        title: "mi-titulo",
      };
    },
    // Normaliza los proyectos de una unidad (el backend los trae en el listado).
    // Tolera distintos nombres de campo y arma una etiqueta legible.
    proyectosDe(item) {
      const arr = item.proyectos ?? item.projects ?? item.proyects ?? [];
      return (arr || []).map((p, i) => {
        if (typeof p === "string") return { key: `${p}-${i}`, label: p };
        const id = p.idProyect ?? p.id ?? p.clave ?? "";
        const nombre = p.nameProyect ?? p.nombre ?? p.name ?? "";
        return {
          key: id || i,
          label: `${id}${nombre ? " · " + nombre : ""}`.trim() || String(id),
        };
      });
    },
    async cargar() {
      this.loading = true;
      try {
        this.unidades = (await getUnidades()) || [];
      } catch (e) {
        console.error(e);
        this.unidades = [];
      } finally {
        this.loading = false;
      }
    },
    formVacio() {
      return {
        id: null,
        nameUnitBussines: "",
        inference_profile: "",
        underlying_model: "",
        aws_region: "",
        sonnet_profile: "",
        sonnet_pricing: "",
        es_base: false,
      };
    },
    abrirCrear() {
      this.editando = false;
      this.form = this.formVacio();
      this.errorNombre = [];
      this.dialog = true;
    },
    abrirEditar(item) {
      this.editando = true;
      this.form = {
        id: item.id,
        nameUnitBussines: item.nameUnitBussines ?? "",
        inference_profile: item.inference_profile ?? "",
        underlying_model: item.underlying_model ?? "",
        aws_region: item.aws_region ?? "",
        sonnet_profile: item.sonnet_profile ?? "",
        sonnet_pricing: item.sonnet_pricing ?? "",
        es_base: !!item.es_base,
      };
      this.errorNombre = [];
      this.dialog = true;
    },
    async guardar() {
      const nombre = (this.form.nameUnitBussines || "").trim();
      if (!nombre) {
        this.errorNombre = ["El nombre es obligatorio"];
        return;
      }
      this.saving = true;
      try {
        const payload = {
          nameUnitBussines: nombre,
          inference_profile: this.form.inference_profile?.trim() || null,
          underlying_model: this.form.underlying_model?.trim() || null,
          aws_region: this.form.aws_region?.trim() || null,
          sonnet_profile: this.form.sonnet_profile?.trim() || null,
          sonnet_pricing: this.form.sonnet_pricing?.trim() || null,
          es_base: !!this.form.es_base,
        };
        if (this.editando) {
          await updateUnidad(this.form.id, payload);
        } else {
          await createUnidad(payload);
        }
        this.dialog = false;
        await this.cargar();
        await swal({
          icon: "success",
          title: this.editando ? "Unidad actualizada" : "Unidad creada",
          timer: 1800,
          showConfirmButton: false,
          customClass: this.popupClass(),
        });
      } catch (e) {
        console.error(e);
        await swal({
          icon: "error",
          title: "Error",
          text: "No se pudo guardar la unidad.",
          customClass: this.popupClass(),
        });
      } finally {
        this.saving = false;
      }
    },
    async eliminar(item) {
      const ok = await swal({
        icon: "warning",
        title: "Eliminar unidad",
        text: `¿Eliminar "${item.nameUnitBussines}"?`,
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#DC2626",
        cancelButtonColor: "#6B7280",
        customClass: this.popupClass(),
      });
      if (!ok.isConfirmed) return;
      try {
        await deleteUnidad(item.id);
        await this.cargar();
        await swal({
          icon: "success",
          title: "Unidad eliminada",
          timer: 1600,
          showConfirmButton: false,
          customClass: this.popupClass(),
        });
      } catch (e) {
        console.error(e);
        await swal({
          icon: "error",
          title: "Error",
          text: "No se pudo eliminar la unidad.",
          customClass: this.popupClass(),
        });
      }
    },
  },
};
</script>
